import { i18n } from "@lingui/core";
import { RecommerceAd } from "../types";
import { useAdContext } from "./AdContext";
import { formatRelativeDate } from "./lib/formatDate";
import { formatDistance } from "./lib/formatDistance";

type AdLocationProps = {
	ad: RecommerceAd;
	className?: string;
};

export function AdLocation(props: AdLocationProps) {
	const { ad, className = "" } = props;

	const { currentTime } = useAdContext();

	const isSold = ad.flags.includes("sold");

	const dateText = isSold
		? i18n.t({
				id: "search.ad.bap.sold",
				message: "Sold",
			})
		: formatRelativeDate(ad.timestamp, { currentTime });
	const distanceText = ad.distance && ad.distance > 0 ? formatDistance(ad.distance) : null;

	return (
		<div className={`flex text-xs s-text-subtle ${className}`}>
			<span className="truncate min-w-0">
				{!ad.distance && ad.location}
				{distanceText}
			</span>
			<span className="whitespace-nowrap ml-1 flex-shrink-0">{dateText}</span>
		</div>
	);
}
